/**
 * Rapor görüntüleyicinin hafif girişi: DevExpress paketleri (~MB) yalnızca bir rapor
 * gerçekten açıldığında indirilir. Ağır iş `ReportViewerHost` içinde.
 */
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/shared/ui/EmptyState';
import { ScreenLoader } from '@/shared/ui/ScreenLoader';
import { usePrefsStore } from '@/entities/preferences/model/prefsStore';
import { resolveTheme } from '@/entities/preferences/lib/applyPrefs';
import type { ReportViewerHostProps } from './ReportViewerHost';

const ReportViewerHost = lazy(() => import('./ReportViewerHost'));

export function ReportViewer({ reportUrl, zoom }: ReportViewerHostProps) {
  const { t } = useTranslation();
  // Görüntüleyici uygulamanın tema ve dilini izler: ayrı bir pencere gibi durmasın.
  // "Sistem" seçiliyken gerçek tema `resolveTheme` ile çözülür.
  const theme = usePrefsStore((s) => s.prefs.theme);
  const language = usePrefsStore((s) => s.prefs.language);

  if (!reportUrl) return <EmptyState title={t('report.noReport')} />;

  return (
    <Suspense
      fallback={
        <ScreenLoader kind="report" className="h-full min-h-40" />
      }
    >
      <ReportViewerHost reportUrl={reportUrl} zoom={zoom} dark={resolveTheme(theme) === 'dark'} language={language} />
    </Suspense>
  );
}
